import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBellSlash } from "@fortawesome/free-solid-svg-icons";

const Button = styled.button`
  display: flex;
  width: 100%;
  border: none;
  background-color: #80d8ff;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  font-size: 1.16rem;
`;

const IconWrapper = styled.span`
  background-color: #fff;
  font-size: 30px;
  border-radius: 25px;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const NotificationPermissionButton = props => {
  const { onClick } = props;
  return (
    <Button onClick={onClick}>
      <span>Allow notifications</span>
      <IconWrapper>
        <FontAwesomeIcon icon={faBellSlash} color="#80D8FF" />
      </IconWrapper>
    </Button>
  );
};

NotificationPermissionButton.propTypes = {
  onClick: PropTypes.func
};

NotificationPermissionButton.defaultProps = {
  onClick: undefined
};

export default NotificationPermissionButton;
